import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

import Modal from "shared/components/feedback/modals/MasterModal";
import RetainersDashboardNotesTable from "features/projects/retainers-dashboard/single/RetainersDashboardNotesTable";
import RetainersDashboardNotesForm from "features/projects/retainers-dashboard/single/RetainersDashboardNotesForm";

const FormPresenter = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const action = searchParams.get("action");
    const id = searchParams.get("id");

    const onClose = () => {
        navigate(".", { replace: true });
    };

    if (action === "add") {
        return (
            <Modal title="Add Note" onRequestClose={onClose}>
                <RetainersDashboardNotesForm key="new" onClose={onClose} />
            </Modal>
        );
    }

    const parsedId = Number.parseInt(id);

    if (action === "edit" && !Number.isNaN(parsedId)) {
        return (
            <Modal title="Edit Note" onRequestClose={onClose}>
                <RetainersDashboardNotesForm
                    noteIdToEdit={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    return <></>;
};

const RetainersDashboardNotes = () => {
    return (
        <>
            <FormPresenter />
            <RetainersDashboardNotesTable />
        </>
    );
};

export default RetainersDashboardNotes;
